module.exports = __webpack_public_path__ + "img/Nora-Logo.2dc191.svg";